const React = require('react');
const { default: Checkbox } = require('@mui/material/Checkbox');
const { default: FormControlLabel } = require('@mui/material/FormControlLabel');

module.exports = function FormCheckboxField(props) {

    const {
        checkboxProps = {},
        field = {},
        label = field.label,
        onBlur,
        onChange,
        onFocus,
        setValue,
        value = false
    } = props;

    return <FormControlLabel
        label={label}
        control={<Checkbox
            checked={!!value}
            onBlur={onBlur}
            onChange={(event) => {

                let nextValue = event.target.checked;

                if (typeof onChange === 'function') {
                    const returnedValue = onChange(nextValue, event);
                    nextValue = typeof returnedValue === 'undefined' ? nextValue : returnedValue;
                }

                if (typeof setValue === 'function') {
                    setValue(nextValue, event);
                }
            }}
            onFocus={onFocus}
            {...checkboxProps}
        />}
    />;
};
